export default {
  'menu.name': 'Menu management',
  'menu.menuName': 'The menu name',
  'menu.menuTags': 'Tag menu',
  'menu.internalComment': 'Note',
  'menu.isActive': 'Active status',
  'menu.create': 'Add menu',
  'menu.update': 'Menu update',
  'menu.information': 'Menu Information',
  'menu.delete': 'Delete the menu',
  'menu.delete.title': 'Delete the menu',
  'menu.content.delete':
    'You are sure to delete the menu. The deleted menu will not help but admire',
};
